import { useEffect, useState } from "react";
import { FlatList, Pressable, StyleSheet, Text, TouchableOpacity, View } from "react-native"
import { DEBUG, enablePromise, openDatabase } from "react-native-sqlite-storage";
import { stopCodes } from "../StockAwareTempData";

const darkColour='#2a2d3e';

interface Data {
  id: number;
  texts: string[];
}

interface List {
  ID: number
  Item_Name: string;
  Month_Start: number;
  Purchased: number;
  Sold: number;
  Remainder: number;
}

const StockCheckView = ({texts,index}: Data & {index: number;}) => {
  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
  const [hovered, setHovered] = useState(false);
  const [isOpacity, setIsOpacity] = useState(false);
  const sizes: number[] = [333, 120, 120, 120, 120];
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity style={{backgroundColor:'transparent'}}>
        <Pressable style={{...styles.childTouchable,  
          backgroundColor: hovered ? '#CCCCCC' : 'transparent', 
          opacity: isOpacity ? 0.2 : 1 }}
          onHoverIn={() => setHovered(true)}
          onHoverOut={() => setHovered(false)}
          onPressIn={() => setIsOpacity(true)}
          onPressOut={() => setIsOpacity(false)}
          >
          {texts.map((text, i) => (
            <View key={i} style={{...styles.childBoxes, width: sizes[i]}}>
              <Text key={i} style={{...styles.childText,  color: darkColour}}>
                {text}
              </Text>
            </View>
          ))}
        </Pressable>
      </TouchableOpacity>
    </View>
  );
};

const Performance = () => {

  const [list, setList] = useState<List[]>([]);
  const [start, setStart] = useState('');
  const [purchased, setPurchased] = useState('');
  const [sold, setSold] = useState('');
  const [remainder, setRemainder] = useState('');

  const loadData = async() => {
    const monthAndYear = (new Date().getFullYear().toString() + '-' + ((new Date().getMonth() + 1).toString()).padStart(2, '0'))
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    (await initDB).transaction((tx) => {
     tx.executeSql(`CREATE TABLE IF NOT EXISTS Monthly_Data (ID INTEGER PRIMARY KEY AUTOINCREMENT, 
      Item_Name TEXT, Quantity INTEGER, Date DATETIME)`, [])

      tx.executeSql(`SELECT * FROM Monthly_Data WHERE strftime('%Y-%m', Date) = ? LIMIT 1`, [monthAndYear], (_, result) => {
        if (result.rows.length > 0) {
          console.log(result.rows.item(0));
        } else if (result.rows.length === 0) {
          tx.executeSql(`INSERT INTO Monthly_Data (Item_Name, Quantity, Date)
            SELECT s.Item_Name, s.Quantity, DATETIME('now', 'start of month') FROM Stocks s
            WHERE s.Item_Name NOT IN (SELECT DISTINCT m.Item_Name FROM Monthly_Data m
                WHERE strftime('%Y-%m', m.Date) = strftime('%Y-%m', DATETIME('now', 'start of month'))
              );`, 
          [], (_, data) => {
            if (data.rows.length > 0) {
              for (let i = 0; i < data.rows.length; i++) {
                console.log(data.rows.item(i))
              }
            }
          })
        }
      })

      tx.executeSql(
        `WITH MonthlyPurchase AS ( SELECT p.Item_Name, SUM(p.Quantity) AS purchased_quantity FROM Purchase_Record p
          WHERE strftime('%Y-%m', p.Last_Updated) = '${monthAndYear}' GROUP BY p.Item_Name),
        NewItems AS ( SELECT p.Item_Name, SUM(p.Quantity) AS new_quantity FROM Purchase_Record p
          WHERE strftime('%Y-%m', p.Last_Updated) = '${monthAndYear}' GROUP BY p.Item_Name),
        Sales AS (SELECT s.Board, SUM(s.Quantity) AS sold_quantity FROM Sales_Items s
          WHERE strftime('%Y-%m', s.Date) = '${monthAndYear}' GROUP BY s.Board),
        Data AS (SELECT COALESCE(m.Item_Name, n.Item_Name, s.Board) AS Item_Name,
            COALESCE(m.Quantity, 0) AS Month_Start,
            COALESCE(n.new_quantity, 0) AS Purchased,
            COALESCE(s.sold_quantity, 0) AS Sold
          FROM Monthly_Data m LEFT JOIN NewItems n ON m.Item_Name = n.Item_Name LEFT JOIN Sales s ON m.Item_Name = s.Board
            WHERE strftime('%Y-%m', m.Date) = '${monthAndYear}' UNION ALL SELECT p.Item_Name AS item_name,
              0 AS at_start_of_month, (SELECT SUM(Quantity) FROM Purchase_Record pr WHERE pr.Item_Name = p.Item_Name
                AND strftime('%Y-%m', pr.Last_Updated) = '${monthAndYear}' GROUP BY pr.Item_Name ) AS purchased, 
                (SELECT SUM(Quantity) FROM Sales_Items si WHERE si.Board = p.Item_Name AND strftime('%Y-%m', si.Date) = '${monthAndYear}'
                  GROUP BY si.Board) AS sold
            FROM Purchase_Record p LEFT JOIN Sales_Items s ON s.Board = p.Item_Name 
                WHERE NOT EXISTS (SELECT 1 FROM Monthly_Data m WHERE m.Item_Name = p.Item_Name
                AND strftime('%Y-%m', m.Date) = '${monthAndYear}') AND strftime('%Y-%m', p.Last_Updated) = '${monthAndYear}'
          GROUP BY p.Item_Name)
          SELECT *, ((Month_Start + Purchased) - Sold) AS Remainder, ROW_NUMBER() OVER () AS ID FROM Data;`
      , [],
    (_, result) => {
      if (result.rows.length > 0) {
        const listArray: List[] = [];
        let st = 0;
        let pcd = 0;
        let sld = 0;
        let rmdr = 0;
        for (let i = 0; i < result.rows.length; i++) {
          listArray.push(result.rows.item(i) as List)
          st += result.rows.item(i).Month_Start;
          pcd += result.rows.item(i).Purchased;
          sld += result.rows.item(i).Sold;
          rmdr += result.rows.item(i).Remainder
          console.log(result.rows.item(i));
        };
        setList(listArray);
        setStart(String(Number(st)?.toLocaleString('en-NG')));
        setPurchased(String(Number(pcd)?.toLocaleString('en-NG')));
        setSold(String(Number(sld)?.toLocaleString('en-NG')));
        setRemainder(String(Number(rmdr)?.toLocaleString('en-NG')));
      }
      console.log(result.rows)
    })
    })
  }

  useEffect(() => {
    if (stopCodes) {
      loadData();
    }
  }, [stopCodes])

  return (
    <View>
      <View>
        <View style = {styles.horizontalSmall}>

        </View>
        <View style = {styles.statsBox}>
          <View style = {styles.headerBox}>
            <View style={{ ...styles.columnHeaderBox, width: 333, borderLeftWidth: 0, marginLeft: 0 }}>
              <Text style={{ ...styles.columnHeaderText }}>Board</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 120}}>
              <Text style={{ ...styles.columnHeaderText }}>Start of Month</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 120 }}>
              <Text style={{ ...styles.columnHeaderText }}>Purchased</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 120 }}>
              <Text style={{ ...styles.columnHeaderText }}>Sold</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 111, borderRightWidth: 0 }}>
              <Text style={{ ...styles.columnHeaderText }}>End of Month</Text>
            </View>
          </View>
          <View style = {styles.listBox}>
          <FlatList
                data={list}
                keyExtractor={(item) => item.ID.toString()}
                renderItem={({ item, index }) => (
                  <StockCheckView
                    key={item.ID}
                    texts={[item.Item_Name, 
                      Number(item.Month_Start)?.toLocaleString('en-NG'), 
                      Number(item.Purchased)?.toLocaleString('en-NG'),
                      Number(item.Sold)?.toLocaleString('en-NG'),
                      item.Remainder?.toString()]}
                    index={index}
                    id={item.ID}
                  />
                )}
              />
          </View>
          <View style = {styles.bottomBox}>
            <View style={{ ...styles.columnHeaderBox, width: 333 }}/>
            <View style={{ ...styles.columnHeaderBox, width: 120}}>
              <Text style={{ ...styles.columnHeaderText }}>{start}</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 120 }}>
              <Text style={{ ...styles.columnHeaderText }}>{purchased}</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 120 }}>
              <Text style={{ ...styles.columnHeaderText }}>{sold}</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 120 }}>
              <Text style={{ ...styles.columnHeaderText }}>{remainder}</Text>
            </View>
          </View>

        </View>
        
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  statsBox: {
    width: 800,
    height: 700,
    borderRadius: 10,
    borderWidth: 2,
    backgroundColor: 'white',
    borderColor:'#DCE3E8', 
    marginHorizontal: 10
  },
  horizontalSmall: {
    width: 800,
    height: 50,
    borderRadius: 10,
    borderWidth: 2,
    backgroundColor: 'white',
    borderColor:'#DCE3E8',
    margin: 10
  },
  headerBox: {
    flexDirection: 'row',
    width: '100%',
    height: 35,
    backgroundColor: darkColour,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  bottomBox: {
    flexDirection: 'row',
    width: '100%',
    height: 35,
    backgroundColor: darkColour,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,

  },
  listBox: {
    flex: 1,
  },
  columnHeaderBox: {
    paddingTop:2,
    borderWidth:2, 
    borderColor:'black', 
    width:57,  
    height:'100%', 
    alignItems:'center',
    borderTopWidth:0,
    marginLeft:-2,
  },
  columnHeaderText: {
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    color:'white', 
    marginTop:6
  },
  childTouchable: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 35,
    borderColor: 'black',
    borderTopWidth: 2,
    borderBottomWidth: 2,
    marginTop: -2,
  },
  childBoxes: {
    borderWidth: 2, 
    borderColor: 'black', 
    height: '100%', 
    alignItems: 'center', 
    marginLeft: -2, 
    borderTopWidth: 0, 
    borderBottomWidth: 0,
  },
  childText: {
    fontFamily: 'century gothic', 
    fontSize: 15, 
    fontWeight: 'normal',
    marginTop: 6,
  },
})

export default Performance;